// Profile-portfolio-card event definitions — emitted by the new
// `<ProfilePortfolioCard>` (spec 081). Two events:
//   1. share button click on the card (BEFORE the share modal opens)
//   2. followers / following KPI button click (BEFORE the dialog opens)

import type { EventDefinition } from './navigation';

export type ProfilePortfolioCardViewerMode = 'own' | 'other';
export type ProfilePortfolioCardKpi = 'followers' | 'following';

export type ProfilePortfolioCardShareClickedProperties = {
  viewerMode: ProfilePortfolioCardViewerMode;
  targetUserId: string;
};

export type ProfilePortfolioCardKpiClickedProperties = {
  viewerMode: ProfilePortfolioCardViewerMode;
  targetUserId: string;
  kpi: ProfilePortfolioCardKpi;
};

export const PROFILE_PORTFOLIO_CARD_SHARE_CLICKED: EventDefinition<ProfilePortfolioCardShareClickedProperties> =
  {
    name: 'profile_portfolio_card_share_clicked',
  };

export const PROFILE_PORTFOLIO_CARD_KPI_CLICKED: EventDefinition<ProfilePortfolioCardKpiClickedProperties> =
  {
    name: 'profile_portfolio_card_kpi_clicked',
  };
